import { useFetchMachine } from 'V2/Hooks/useFetchMachine';
import { RateResponseType, RateType } from 'V2/Types/Rate';
import {
  ConfigurationResponseType,
  ConfigurationType,
} from 'V2/Types/Configuration';
import { AppDetailsResponseType, AppDetailsType } from 'V2/Types/AppDetails';
import { DictionaryResponseType, DictionaryType } from 'V2/Types/Dictionary';

import {
  AppDetailsResourceType,
  ConfigurationResourceType,
  RateResourceType,
  SaveAppDataResourceType,
  DictionaryResourceType,
  CatalogResourceType,
} from './types';
import {
  transformAppDetails,
  transformConfigResponse,
  transformRateResponse,
} from './transformers';
import { transformDictionaryResponse } from './transformers/dictionary.transformer';

const RATE_URL = '/insurance_applications/:appId/rate';
const CONFIGURATION_URL = '/insurance_applications/:appId/configuration';
const UPDATE_APP_DETAILS_URL = '/insurance_applications/:appId/update';
const APP_DETAILS_URL = '/insurance_applications/:appId/details';
const DICTIONARY_URL = '/insurance_applications/:appId/dictionary';
const BASE_CATALOG_URL = '/insurance_applications/:appId/options';

export const useRate: RateResourceType = ({ appId }) => {
  return useFetchMachine<RateType>(RATE_URL.replace(':appId', appId), {
    method: 'POST',
    transformResponse: (response) => {
      return transformRateResponse(response as RateResponseType);
    },
  });
};

export const useConfig: ConfigurationResourceType = ({ appId }) => {
  return useFetchMachine<ConfigurationType>(
    CONFIGURATION_URL.replace(':appId', appId),
    {
      method: 'GET',
      transformResponse: (response) => {
        return transformConfigResponse(response as ConfigurationResponseType);
      },
    }
  );
};

export const useAppDetails: AppDetailsResourceType = ({ appId }) => {
  return useFetchMachine<AppDetailsType>(
    APP_DETAILS_URL.replace(':appId', appId),
    {
      method: 'GET',
      transformResponse: (response) => {
        return transformAppDetails(response as AppDetailsResponseType);
      },
    }
  );
};

export const useSaveAppData: SaveAppDataResourceType = ({ appId }) => {
  return useFetchMachine<AppDetailsType>(
    UPDATE_APP_DETAILS_URL.replace(':appId', appId),
    {
      method: 'POST',
      transformResponse: (response) => {
        return transformAppDetails(response as AppDetailsResponseType);
      },
    }
  );
};

export const useDictionary: DictionaryResourceType = ({ appId }) => {
  return useFetchMachine<DictionaryType>(
    DICTIONARY_URL.replace(':appId', appId),
    {
      method: 'GET',
      transformResponse: (response) =>
        transformDictionaryResponse(response as DictionaryResponseType),
    }
  );
};

export const useCatalog: CatalogResourceType = ({ appId }) => {
  return useFetchMachine<any>(BASE_CATALOG_URL.replace(':appId', appId), {
    method: 'GET',
  });
};
